import * as React from 'react'
import { createRoot } from 'react-dom/client'
import FroalaEditor from 'froala-editor'
import VariableList from '../components/VariableList';

FroalaEditor.ICON_TEMPLATES = {
	...FroalaEditor.ICON_TEMPLATES,
	svgFull: '[SVG]'
}

// Define popup template.
FroalaEditor.POPUP_TEMPLATES["variablePlugin.popup"] = '[_BUTTONS_][_CUSTOM_LAYER_]';

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.variablePlugin = function (editor) {
	// Create custom popup.
	function initPopup() {
		var variables = editor.opts.variableOptions || []

		// Load popup template.
		var template = {};

		// Create popup.
		var $popup = editor.popups.create('variablePlugin.popup', template);

		createRoot($popup[0]).render(<VariableList
			variables={variables}
			onClick={onItemSelect}
		/>)

		return $popup;
	}

	// Show the popup
	function showPopup() {
		// Get the popup object defined above.
		var $popup = editor.popups.get('variablePlugin.popup');

		// If popup doesn't exist then create it.
		// To improve performance it is best to create the popup when it is first needed
		// and not when the editor is initialized.
		if (!$popup) $popup = initPopup();

		// Set the editor toolbar as the popup's container.
		editor.popups.setContainer('variablePlugin.popup', editor.$tb);

		// This will trigger the refresh event assigned to the popup.
		// editor.popups.refresh('variablePlugin.popup');

		// This custom popup is opened by pressing a button from the editor's toolbar.
		// Get the button's object in order to place the popup relative to it.
		var $btn = editor.$tb.find('.fr-command[data-cmd="variable"]');

		// Set the popup's position.
		var left = $btn.offset().left + $btn.outerWidth() / 2;
		var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);

		// Show the custom popup.
		// The button's outerHeight is required in case the popup needs to be displayed above it.
		editor.popups.show('variablePlugin.popup', left, top, $btn.outerHeight());
	}

	// Hide the custom popup.
	function hidePopup() {
		editor.popups.hide('variablePlugin.popup');
	}

	function onItemSelect(variable: string) {
		editor.html.insert(variable);
		editor.undo.saveStep();
		hidePopup()
	}

	// Methods visible outside the plugin.
	return {
		showPopup: showPopup,
		hidePopup: hidePopup,

	}
}


FroalaEditor.DefineIcon('variableIcon', { NAME: 'star', template: 'svgFull', SVG: '<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd"> <g id="brackets" fill="#000000" fill-rule="nonzero"> <path d="M5.05559044,0 L3.8889447,0 C2.6003034,-4.4408921e-16 1.55565322,1.34314575 1.55565322,3 L1.55565322,4.17125 C1.55559086,4.43670335 1.47359505,4.69127454 1.3276712,4.8790625 L0.227864538,6.2928125 C0.0819671177,6.48035544 2.52554342e-17,6.73474395 0,7 C-2.52554342e-17,7.26525605 0.0819671177,7.51964456 0.227864538,7.7071875 L1.3276712,9.12125 C1.4736117,9.3087682 1.55562206,9.56315976 1.55565322,9.8284375 L1.55565322,11 C1.55565322,12.6568542 2.6003034,14 3.8889447,14 L5.05559044,14 C5.27036399,14 5.44447235,13.7761424 5.44447235,13.5 L5.44447235,12.5 C5.44447235,12.2238576 5.27036399,12 5.05559044,12 L3.8889447,12 C3.4593976,12 3.11118087,11.5522847 3.11118087,11 L3.11118087,9.82875 C3.11115186,9.03296166 2.86521024,8.26979328 2.42747786,7.7071875 L1.87769605,7 L2.42772091,6.2928125 C2.86536416,5.73015555 3.11121632,4.96699348 3.11118087,4.17125 L3.11118087,3 C3.11118087,2.44771525 3.4593976,2 3.8889447,2 L5.05559044,2 C5.27036399,2 5.44447235,1.77614237 5.44447235,1.5 L5.44447235,0.5 C5.44447235,0.223857625 5.27036399,0 5.05559044,0 Z M13.7721355,6.2928125 L12.6723288,4.8790625 C12.5264049,4.69127454 12.4444091,4.43670335 12.4443468,4.17125 L12.4443468,3 C12.4443468,1.34314575 11.3996966,2.22044605e-16 10.1110553,0 L8.94440956,0 C8.72963601,0 8.55552765,0.223857625 8.55552765,0.5 L8.55552765,1.5 C8.55552765,1.77614237 8.72963601,2 8.94440956,2 L10.1110553,2 C10.5406024,2 10.8888191,2.44771525 10.8888191,3 L10.8888191,4.1709375 C10.8887192,4.96694242 11.1346706,5.73036611 11.5725221,6.293125 L12.1223039,7 L11.5725221,7.7071875 C11.1347898,8.26979328 10.8888481,9.03296166 10.8888191,9.82875 L10.8888191,11 C10.8888191,11.5522847 10.5406024,12 10.1110553,12 L8.94440956,12 C8.72963601,12 8.55552765,12.2238576 8.55552765,12.5 L8.55552765,13.5 C8.55552765,13.7761424 8.72963601,14 8.94440956,14 L10.1110553,14 C11.3996966,14 12.4443468,12.6568542 12.4443468,11 L12.4443468,9.8284375 C12.4443779,9.56315976 12.5263883,9.3087682 12.6723288,9.12125 L13.7721355,7.7071875 C13.9180329,7.51964456 14,7.26525605 14,7 C14,6.73474395 13.9180329,6.48035544 13.7721355,6.2928125 Z" id="Shape"></path> </g> </g> </svg>' })

FroalaEditor.RegisterCommand('variable', {
	title: 'Insert variable',
	icon: 'variableIcon',
	undo: true,
	focus: true,
	plugin: 'variablePlugin',
	callback: function () {
		this.variablePlugin.showPopup();
	}
});

FroalaEditor.RegisterQuickInsertButton('variable', {
	icon: 'variableIcon',
	title: 'Insert variable',
	undo: true,
	focus: true,
	plugin: 'variablePlugin',
	// Callback for the button.
	callback: function () {
		// Call any editor method here.
		this.variablePlugin.showPopup();
	},
})
